import React, { useState } from "react";
import Button from "../../../../components/common/button";
import { colors } from "../../../../share/constants/enums";
import { Form, Input as InputField, message } from "antd";
import { Link } from "react-router-dom";
import { changePassword } from "../../../../api/auth";

const Settings = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [payload, setPayload] = useState({
    email: localStorage.getItem("email"),
    currentPassword: "",
    newPassword: "",
  });
  const onFinish = async () => {
    setLoader(true);
    try {
      form.validateFields();
      const res = await changePassword(payload);
      if (res) {
        message.success("Your Password has been updated!");
        form.resetFields();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const handleFormChange = (changedValues) => {
    if (!changedValues.repeatPassword) {
      setPayload({ ...payload, ...changedValues });
    }
  };

  return (
    <>
      <div className="p-3">
        <div>
          <p className="text-lg font-medium tracking-wider">Change Password</p>
        </div>
        <div className="p-2 border-solid border-inputFieldGrey rounded-sm justify-center items-center">
          <Form
            form={form}
            onFinish={onFinish}
            onValuesChange={handleFormChange}
          >
            <div className="w-full xl:grid xl:grid-cols-3 xl:gap-2 xl:content-center justify-between">
              <Form.Item
                name="currentPassword"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
                className="w-full sm:w-full md:w-full lg:w-full xl:w-auto"
              >
                <InputField.Password
                  className={" w-full h-5.4  hover:border-primaryBlue"}
                  placeholder="Current Password"
                />
              </Form.Item>

              <Form.Item
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value.length >= 6 && /[A-Z]/.test(value))
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Password must be at least 6 characters with 1 uppercase letter"
                      );
                    },
                  }),
                ]}
                className="w-full sm:w-full md:w-full lg:w-full xl:w-auto"
              >
                <InputField.Password
                  className="w-full h-5.4 hover:border-primaryBlue"
                  placeholder="New Password"
                />
              </Form.Item>

              <Form.Item
                name="repeatPassword"
                dependencies={["newPassword"]}
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
                className="w-full sm:w-full md:w-full lg:w-full xl:w-auto"
              >
                <InputField.Password
                  className="w-full h-5.4 hover:border-primaryBlue"
                  placeholder="Repeat Password"
                />
              </Form.Item>
            </div>
            <div className="flex ">
              <p className="w-full text-primaryBlue">
                <Link
                  to="/forgot-password"
                  className=" text-primaryPurple no-underline"
                >
                  Forgot Password?
                </Link>
              </p>
              <Form.Item className="w-full flex justify-end">
                <Button
                  color={colors.primaryPurple}
                  title="Save"
                  htmlType="submit"
                  loading={loader}
                  className="w-19"
                />
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Settings;
